'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { setSentryTag, clearSentryTag } from '@/modules/sentry/sentry.utils';
import type { SlimTenant } from '@/modules/tenant';
type SentryTenantContextProps = {
  tenant?: Pick<SlimTenant, 'id' | 'name' | 'display_name'>;
};

/**
 * 🏢 Tenant-level Sentry tags registry
 * Sets tenant tags for error tracking using flat naming with underscores
 * Only clears tenant tags on unmount (isolation)
 */
export default function SentryTenantContext(t0) {
  const $ = _c(3);
  const {
    tenant
  } = t0;
  let t1;
  let t2;
  if ($[0] !== tenant) {
    t1 = () => {
      if (tenant) {
        setSentryTag("tenant_id", tenant.id);
        setSentryTag("tenant_name", tenant.name);
      }
      return () => {
        if (tenant) {
          clearSentryTag("tenant_id");
          clearSentryTag("tenant_name");
        }
      };
    };
    t2 = [tenant];
    $[0] = tenant;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}